import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { UserDatetimeService } from './user-datetime.service';

@Injectable({
  providedIn: 'root',
})
export class ApiBaseService {
  protected apiUrl = environment.apiUrl;

  constructor(protected readonly http: HttpClient, protected readonly userDatetimeService: UserDatetimeService) {}

  protected createQueryParams(params: Record<string, any>): HttpParams {
    if (params) {
      let httpParams = new HttpParams();
      for (const [key, value] of Object.entries(params)) {
        if (value !== '' && value !== null && typeof value !== 'undefined') {
          if (value instanceof Date) {
            httpParams = httpParams.append(key, this.userDatetimeService.convertToAPIDate(value));
          } else if (value instanceof Array) {
            value.forEach((v) => (httpParams = httpParams.append(key, String(v))));
          } else {
            httpParams = httpParams.append(key, String(value));
          }
        }
      }
      return httpParams;
    }
  }
}
